export default __webpack_public_path__ + "static/media/baner.0382139d.png";